module.exports = "\n\n\n\n\n\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/profile/panels/utilization/utilization.component.css
// module id = ./src/app/profile/panels/utilization/utilization.component.css
// module chunks = main